export default __webpack_public_path__ + "static/media/cortina-inicio-mobile.317a366e.jpg";